import { CommonModule } from '@angular/common';
import { Component, inject, Input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ObjectType, ProfileHeaderComponentInterface, StandardIds, UpdaterService } from '@galaxy/crm/static';
import { CrmObjectInterface, CurrencyInterface } from '@vendasta/crm';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

@Component({
  templateUrl: './opportunity-value.component.html',
  styleUrls: ['./opportunity-value.component.scss'],
  imports: [CommonModule, GalaxyPipesModule],
})
export class CrmOpportunityValueComponent implements ProfileHeaderComponentInterface {
  @Input() crmObjectType: ObjectType | undefined;

  private _crmObject?: CrmObjectInterface;
  @Input()
  set crmObject(value: CrmObjectInterface) {
    this._crmObject = value;
    const valueField = value?.fields?.find((f) => f.fieldId === StandardIds.OpportunityAmount)?.currencyValue;
    this.value.set(valueField);
  }
  get crmObject(): CrmObjectInterface | undefined {
    return this._crmObject;
  }

  private readonly updaterService = inject(UpdaterService);
  protected value = signal<CurrencyInterface | undefined>(undefined);

  constructor() {
    this.updaterService.updatedField.pipe(takeUntilDestroyed()).subscribe((fieldChanged) => {
      if (fieldChanged?.fieldId === StandardIds.OpportunityAmount) {
        this.value.set(fieldChanged?.currencyValue);
      }
    });
  }
}
